import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output, Optional, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import * as _ from 'lodash-es';
import { Form1065M2Service } from './form1065-m2.service';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { JsonObjectFactoryService } from '../../../shared/_services/json-object-factory.service';
import { Subscription } from 'rxjs';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import { safeEvalFormula, isFiniteEvalNumber } from '../../../shared/_utils/safe-eval-formula';

import {
	buildHeaderDataShell,
	generalConfigFromGlobal,
	normalizeFilterParams,
	rowPayloadFromActiveScreen,
	hydratedGlobalParams,
} from '../../../shared/workspace-element-context';

@Component({
    selector: 'gtw-form1065-m2',
    templateUrl: './form1065-m2.component.html',
    styleUrls: ['./form1065-m2.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class Form1065M2Component implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);

	baseGlobalParams: { 
		jcd_key: string; 
		tax_year: string; 
		scenario: string; 
		client_key: string; 
		issue_id: string, 
		is_issue_key_enabled: string; 
		scenarioCode: string,
		screen_key: string
	} | undefined;

	@Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();
	private readonly subs = new Subscription();
	baseURLs: any ={'admin':'','api':'',"custom":'','efile':'','pdfEngine':'','bulkPdfEngine':''};
	globalService: any;
	appService: any = {
		USER_SETTINGS: '',
		SERVER_CONFIG: ''
	};
	GENERAL_CONFIG : any;
	activeTab = 1;
	batchSelect = false;
	minimise = false;
	crudLoading = false;
	rowData: any = {};
  
	filterParams: any = {};

	userSettings: any = this.appService.USER_SETTINGS;
	logged_in_user: string = '';
	defaultsMultipleSelected: any[] = [];
	gridData: any = {};
	partnerShipObj: any = {};
	currentyear: any;
	isSaveClicked = false;
	loadingData = true;
	loadingTableData = true;
	pendingApiCalls = 0;
	tableHeader: any[] = [];
	originalTabsList: any[] = [];
	originalTablsOutterList: any[] = [];
	issue_description = '';
	scenarioLabel: string = '';
	title: string = '';
	section_name: string = '';
	formHeader: any;
	formList: any[] = [];
	outerList: any[] = [];
	originalData: any;
	originalOutterData: any;
	formCalcData: any[] = [];
	gridDataMultipleSelect: any;
	scheduleM2SaveList: any[] = [];
	currentFormula: any;
	Math = Math;

	constructor(
		private gtwGlobal: GlobalService,
		private gtwWorkspace: WorkspaceService,
		private gtwApp: AppService,
		private dialog: MatDialog,
		@Optional() @Inject(MAT_DIALOG_DATA) public data: { rowData: any, gridData: any } | null,
		private jsonObjectFactory: JsonObjectFactoryService,
		private f1065ScheduleM2ServiceFactory: Form1065M2Service,
		private gtwSnackbarService: GtwSnackbarService
	) {}

	ngOnInit(): void {
		this.applyWorkspaceContext();
		this.subs.add(this.gtwWorkspace.setTabActive.subscribe(() => {
			this.applyWorkspaceContext();
			this.init();
		}));
		this.subs.add(this.gtwGlobal.globalParamsChanged$.subscribe(() => {
			this.applyWorkspaceContext();
			this.init();
		}));
		this.init();
	}

	ngOnDestroy(): void {
		this.subs.unsubscribe();
	}

	private applyWorkspaceContext(): void {
		const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
		const header = buildHeaderDataShell(this.gtwGlobal, this.gtwApp);
		this.baseURLs = generalConfigFromGlobal(this.gtwGlobal);
		this.globalService = header || {};
		this.appService.USER_SETTINGS = header.userSettingsData || {};
		this.appService.SERVER_CONFIG = header.serverConfigData || {};
		this.GENERAL_CONFIG = header.generalConfigData || {};
		this.rowData = rowPayloadFromActiveScreen(activeScreen);
		this.filterParams = normalizeFilterParams(activeScreen);
		this.baseGlobalParams = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace);
	}

	init() {
		if (!this.baseURLs || !this.GENERAL_CONFIG || !this.globalService || !this.rowData || !this.filterParams) {
			return;
		}
		
		this.logged_in_user = this.appService?.USER_SETTINGS?.user?.sso_id || '';
		
		const filterParams = this.filterParams;
		this.currentyear = filterParams.tax_year;
		this.scenarioLabel = this.globalService?.globalParams?.scenario_desc || '';
		this.title = `Edit M-2/K-1 Partner Capital Accounts on a tax basis or 704b basis ( Tax Year: ${this.currentyear} - Scenario: ${this.scenarioLabel} )`;

		if (!this.baseGlobalParams || !Object.keys(this.baseGlobalParams).length) {
			this.baseGlobalParams = this.globalService?.globalParams;
		}

		if (this.rowData != null && Object.keys(this.rowData).length > 0) {
			const tempGridData = _.clone(this.rowData);
			this.gridDataMultipleSelect = _.clone(tempGridData);

			if (this.gridDataMultipleSelect !== undefined) {
				const rowData = this.gridDataMultipleSelect;
				this.partnerShipObj = {
					combination_key: rowData.COMBINATION_KEY,
					leid: rowData.LEID,
					tax_code: rowData.CDR_NO,
					reporting_period: rowData.REPORTING_PERIOD,
					me_code: rowData.ME_CODE,
					entity_name: rowData.LE_NAME,
					tax_year_begin: this.formatDate(rowData.TAX_YEAR_BEGIN, 'MM/dd'),
					tax_year_end: this.formatDate(rowData.TAX_YEAR_END, 'MM/dd/yyyy')
				};
			}
		}
		
		this.fetch1065PartnerRecords();
	}

	formLineKey(transfer: any) {
		return transfer.FORM_LINE_KEY;
	  }

	fetch1065PartnerRecords(): void {
		this.startApiCall();
		
		const rowData = this.rowData;
		
		if (rowData && rowData.F1065_M2K1_1_OVERRIDE_TAX_0 !== undefined) {
			this.section_name = 'TAX';
		} else if (rowData && rowData.F1065_M2K1_1_OVERRIDE_0 !== undefined) {
			this.section_name = 'GAAP';
		}
		
		const params = {
			action_code: '74y1n1',
			sso_id: this.logged_in_user,
			tax_year: this.currentyear,
			scenario: this.baseGlobalParams?.scenario,
			jcd_key: this.baseGlobalParams?.jcd_key,
			combination_key: rowData?.COMBINATION_KEY,
			jcd_ta_key: null,
			section_name: this.section_name
		};
		
		this.jsonObjectFactory.getJSONObj(this.baseURLs.api + '/loadJsonObject', params, this.globalService, null, null).pipe(takeUntilDestroyed(this.destroyRef))
		.subscribe(
			(data: any) => {
				
				if (data.jsonObject && data.jsonObject.length > 0) {
					
					if (data.jsonObject[0].ISSUE_KEY !== 0) {
						this.issue_description = data.jsonObject[0].ISSUE_SHORT_DESC;
					} else {
						this.issue_description = '';
					}
					
					this.formHeader = data.jsonObject.filter((obj: any) => obj.ROW_TYPE === 'FH');
					this.tableHeader = data.jsonObject.filter((obj: any) => obj.ROW_TYPE === 'TH');
					
					this.formList = data.jsonObject.filter((obj: any) => obj.ROW_TYPE !== 'FH' && obj.ROW_TYPE !== 'TH');
					
					this.outerList = [];
					for (let i = 0; i < this.formList.length; i++) {
						if (this.formList[i].FORM_LINE_KEY != null) {
							let tempCheck1: any[] = [];
							if (this.outerList != null && this.outerList.length > 0) {
								tempCheck1 = this.outerList.filter((o: any) =>
									o.FORM_LINE_KEY === this.formList[i].FORM_LINE_KEY && o.IS_FORM_DISPLAY === 'Y'
								);
							}
							if (tempCheck1 === undefined || tempCheck1.length === 0) {
								this.outerList.push(this.formList[i]);
							}
						}
					}
					
					
					this.originalData = _.cloneDeep(this.formList);
					this.originalOutterData = _.cloneDeep(this.outerList);

					this.originalTabsList.push(this.originalData);
					this.originalTablsOutterList.push(this.originalOutterData);

					this.finishApiCall(); // This API call is done
					this.fetchModalCalcData();
				} else {
					this.finishApiCall(); // This API call is done
				}
			},
			(error: any) => {
				console.error('API error in fetch1065PartnerRecords:', error);
				this.finishApiCall(); // This API call failed
			}
		);
	}

	itemTracker(item: any): string {
		return item.LINE_ORDER + '-' + item.ATTRIB_ORDER;
	}

	// Helper methods to track API calls and manage loading state
	startApiCall(): void {
		this.pendingApiCalls++;
		this.loadingData = true;
		this.loadingTableData = true;
	}

	finishApiCall(): void {
		this.pendingApiCalls--;
		if (this.pendingApiCalls <= 0) {
			this.pendingApiCalls = 0;
			this.loadingData = false;
			this.loadingTableData = false;
		}
	}

	cancelForm(){
		this.dialog.closeAll();
	}
	

	fetchModalCalcData(order?: any): void {
		this.startApiCall();
		
		const params = {
			action_code: 'veltqh',
			tax_year: this.currentyear,
			scenario: this.baseGlobalParams?.scenario,
			jcd_key: this.baseGlobalParams?.jcd_key,
			form_no: '1065',
			schedule_name: 'M2K1',
			part_no: null,
			section_name: this.section_name
		};
		
		this.jsonObjectFactory.getJSONObj(this.baseURLs.api + '/loadJsonObject', params, this.globalService, null, null).pipe(takeUntilDestroyed(this.destroyRef))
		.subscribe(
			(data: any) => {
				this.formCalcData = data.jsonObject;
				this.finishApiCall();
			},
			(error: any) => {
				console.error('API error in fetchModalCalcData:', error);
				this.finishApiCall();
			}
		);
	}

	allocate(): void {
		// Exclude lines 5,8,9 because we don't want to allocate amounts for total lines
		const partnerAttributes = this.formList.filter((o: any) =>
			o.ATTRIB_CLASS === 'PTR_ATTRIB' && (o.LINE_NO != '5' && o.LINE_NO != '8' && o.LINE_NO != '9')
		);

		// Group partners by unique line identifier to avoid duplicate processing
		const lineGroups = new Map<string, any[]>();
		
		partnerAttributes.forEach(partner => {
			const lineKey = `${partner.LINE_ORDER}_${partner.LINE_NO}`;
			if (!lineGroups.has(lineKey)) {
				lineGroups.set(lineKey, []);
			}
			lineGroups.get(lineKey)!.push(partner);
		});

		// Process each unique line
		for (const [lineKey, linePartners] of lineGroups) {
			const [lineOrder, lineNo] = lineKey.split('_');

			// Find override attribute for this line
			const overrideAttribute = this.formList.filter((o: any) =>
				o.ATTRIB_CLASS === 'DEF_ATTRIB' && 
				o.LINE_ORDER === parseInt(lineOrder) && 
				o.ATTRIB_COL === 'b'
			);

			if (overrideAttribute.length === 0) {
				continue;
			}

			const totalAmount = Number(overrideAttribute[0].ATTRIB_VALUE);

			// Skip if no amount to allocate
			if (totalAmount === 0) {
				// Set all partners to 0 for this line
				linePartners.forEach(partner => {
					partner.ATTRIB_VALUE = '0';
				});
				continue;
			}

			// Calculate allocations for all partners on this line
			let allocatedSum = 0;
			for (let i = 0; i < linePartners.length; i++) {
				const partner = linePartners[i];
				
				if (i === linePartners.length - 1) {
					// Last partner gets the remainder to avoid rounding errors
					const remainingAmount = totalAmount - allocatedSum;
					partner.ATTRIB_VALUE = Math.round(remainingAmount).toString();
				} else {
					// Calculate proportional amount based on posting ratio
					const postingRatio = Number(partner.POSTING_RATIO);
					const allocatedAmount = totalAmount * postingRatio;
					partner.ATTRIB_VALUE = Math.round(allocatedAmount).toString();
					allocatedSum += Math.round(allocatedAmount);
				}

				// Special case: TAX section line 3 keeps original value
				if (this.section_name === 'TAX' && partner.LINE_NO == '3') {
					// Don't change the value for TAX section line 3
					// Keep original value unchanged
				}
			}
		}

		// Calculate amounts for line 5,8,9 on allocate by calc Formula (as per original logic)
		const processedAttributes: any[] = [];
		
		// Get all override attributes and line partners that were involved in allocation
		for (const [lineKey, linePartners] of lineGroups) {
			const [lineOrder, lineNo] = lineKey.split('_');
			
			// Add override attributes
			const overrideAttribs = this.formList.filter((o: any) =>
				o.ATTRIB_CLASS === 'DEF_ATTRIB' && 
				o.LINE_ORDER === parseInt(lineOrder) && 
				o.ATTRIB_COL === 'b'
			);
			processedAttributes.push(...overrideAttribs);
			
			// Add the actual line partners that were processed
			processedAttributes.push(...linePartners);
		}
		
		// Validate the specific attributes that were processed (matches original logic)
		for (let c = 0; c < processedAttributes.length; c++) {
			this.validateSubForm(processedAttributes[c]);
		}
	}

	varianceCalc(): void {
		// ALL VARIANCE ATTRIBUTES
		const varianceAttributes = this.formList.filter((o: any) =>
		o.ATTRIB_CLASS === 'DEF_ATTRIB' && o.ATTRIB_COL === 'c'
		);
		for (let v = 0; v < varianceAttributes.length; v++) {
		const overrideAttribute = this.formList.filter((o: any) =>
			o.ATTRIB_CLASS === 'DEF_ATTRIB' && o.LINE_ORDER === varianceAttributes[v].LINE_ORDER && o.ATTRIB_COL === 'b'
		);
		// will give all partners for that line
		const allPartnerAttributes = this.formList.filter((o: any) =>
			o.ATTRIB_CLASS === 'PTR_ATTRIB' && o.LINE_ORDER === varianceAttributes[v].LINE_ORDER
		);
		let totalSum = 0;
		for (let x = 0; x < allPartnerAttributes.length; x++) {
			totalSum += parseInt(allPartnerAttributes[x].ATTRIB_VALUE, 10);
		}
		// variance Calc
		const varianceCalcVal = Number(overrideAttribute[0].ATTRIB_VALUE) - totalSum;
		if (this.section_name === 'TAX' && varianceAttributes[v].LINE_NO == '3') {
			varianceAttributes[v].ATTRIB_VALUE = varianceAttributes[v].ATTRIB_VALUE;
		} else {
			varianceAttributes[v].ATTRIB_VALUE = Math.round(varianceCalcVal).toString();
		}
		}
	}

	validateSubForm(line: any): void {
		if (line == null || line.DATA_TYPE === 'number') {
		let calcData = this.formCalcData;
		if (!calcData || calcData.length === 0) {
			// Fallback: derive from formList
			calcData = this.formList.filter((o: any) =>
				o.ATTRIB_CALC_FORMULA && o.ATTRIB_CALC_FORMULA.trim().length > 0
			);
		}
		for (let g = 0; g < calcData.length; g++) {
			this.calcAmt(
			calcData[g].ATTRIB_CALC_FORMULA,
			calcData[g].LINE_NO,
			calcData[g].LINE_ATTRIB_KEY,
			calcData[g].LINE_ORDER,
			calcData[g].ATTRIB_ORDER,
			line.ATTRIB_ORDER,
			line.ATTRIB_CLASS
			);
		}
		this.varianceCalc();
		}
	}

	onInputChange(event: Event, row1: any) {
		const target = event.target as HTMLInputElement;
		if (target) {
			// Clean the input value to ensure only valid characters
			const cleanedValue = this.cleanNumericInput(target.value);
			if (cleanedValue !== target.value) {
				target.value = cleanedValue;
			}
			row1.ATTRIB_VALUE = cleanedValue;
			this.validateSubForm(row1);
		}
	}

	onKeyPress(event: KeyboardEvent): boolean {
		const char = String.fromCharCode(event.which);
		const input = event.target as HTMLInputElement;
		const currentValue = input.value;
		
		// Allow digits (0-9)
		if (/[0-9]/.test(char)) {
			return true;
		}
		
		// Allow minus sign only at the beginning and if not already present
		if (char === '-') {
			const selectionStart = input.selectionStart || 0;
			// Only allow minus at the beginning and if there's no minus already
			if (selectionStart === 0 && !currentValue.includes('-')) {
				return true;
			}
		}
		
		// Allow backspace, delete, tab, escape, enter
		const allowedKeys = [8, 9, 27, 13, 46];
		if (allowedKeys.includes(event.keyCode)) {
			return true;
		}
		
		// Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
		if (event.ctrlKey && [65, 67, 86, 88].includes(event.keyCode)) {
			return true;
		}
		
		// Prevent default for all other characters
		event.preventDefault();
		return false;
	}

	onPaste(event: ClipboardEvent): void {
		event.preventDefault();
		const pastedText = event.clipboardData?.getData('text') || '';
		const cleanedText = this.cleanNumericInput(pastedText);
		
		const input = event.target as HTMLInputElement;
		if (input && cleanedText) {
			// Insert cleaned text at cursor position
			const start = input.selectionStart || 0;
			const end = input.selectionEnd || 0;
			const currentValue = input.value;
			const newValue = currentValue.substring(0, start) + cleanedText + currentValue.substring(end);
			input.value = this.cleanNumericInput(newValue);
			
			// Trigger input event to update the model
			const inputEvent = new Event('input', { bubbles: true });
			input.dispatchEvent(inputEvent);
		}
	}

	private cleanNumericInput(value: string): string {
		if (!value) return '';
		
		// Remove all characters except digits and minus sign
		let cleaned = value.replace(/[^0-9-]/g, '');
		
		// Ensure minus sign is only at the beginning
		const minusCount = (cleaned.match(/-/g) || []).length;
		if (minusCount > 0) {
			// Remove all minus signs
			cleaned = cleaned.replace(/-/g, '');
			// Add one minus at the beginning if original had any minus
			if (value.includes('-')) {
				cleaned = '-' + cleaned;
			}
		}
		
		return cleaned;
	}

	calcAmt(
		formula: string,
		line_no: any,
		attrib_key: any,
		line_order: any,
		attrib_order: any,
		line_attrib_order: any,
		attrib_class: any
	): void {
		this.currentFormula = formula;
		let lineFormulaArray: string[] = [];
		const matches = formula.match(/\b[^\d\s]+\b/g);
		if (matches == null) {
		lineFormulaArray = formula.split(/[+\-/*]/);
		} else {
		const formulaLength = formula.length;
		const subFormula = formula.substring(formula.indexOf('('), formulaLength - 1);
		lineFormulaArray = subFormula.split(/[+\-,/*]/);
		}

		for (let i = 0; i < lineFormulaArray.length; i++) {
	try {
		if (lineFormulaArray[i].indexOf('(') > -1 && lineFormulaArray[i].indexOf(')') > -1) {
			lineFormulaArray[i] = lineFormulaArray[i].replace(/"/g, '').replace(/'/g, '').replace(/\(|\)/g, '');

			const currentTabNewAtrribVal = this.formList.filter((o: any) =>
			o.ATTRIB_SHORT_CODE === lineFormulaArray[i].trim()
			);

			let lineAmt = 0;
			if (attrib_class === 'PTR_ATTRIB') {
			// get all partners to sum total lines
			const allPartnersAttribs = this.formList.filter((o: any) =>
			o.ATTRIB_ORDER == line_attrib_order && o.ATTRIB_CLASS === 'PTR_ATTRIB'
			);
			const currentPartnerNewAtrribVal = allPartnersAttribs.filter((o: any) =>
				o.ATTRIB_SHORT_CODE === currentTabNewAtrribVal[0].ATTRIB_SHORT_CODE.trim()
			);
			lineAmt = parseFloat(currentPartnerNewAtrribVal[0].ATTRIB_VALUE);
			} else {
			lineAmt = parseFloat(currentTabNewAtrribVal[0].ATTRIB_VALUE);
			}

			if (parseFloat(lineAmt as any) >= 0) {
			formula = formula.replace('(' + lineFormulaArray[i].trim() + ')', lineAmt.toString());
			} else {
			formula = formula.replace('(' + lineFormulaArray[i].trim() + ')', '(' + lineAmt + ')');
			}
			}
		} catch (e) {
			console.warn('[M2] calcAmt error for term:', lineFormulaArray[i], e);
		}
		}

		let calculatedVal: any;
		try {
		calculatedVal = safeEvalFormula(formula, null, 'form1065-m2');
		} catch (e) {
		calculatedVal = null;
		}
		if (calculatedVal !== null && typeof calculatedVal !== 'undefined' && isFiniteEvalNumber(calculatedVal)) {
		let changedFormulaAttribVal: any[] = [];
		if (attrib_class === 'PTR_ATTRIB') {
			changedFormulaAttribVal = this.formList.filter((o: any) =>
			o.LINE_NO == line_no && o.LINE_ORDER == line_order && o.ATTRIB_ORDER == line_attrib_order
			);
		} else {
			changedFormulaAttribVal = this.formList.filter((o: any) =>
			o.LINE_NO == line_no && o.LINE_ORDER == line_order && o.ATTRIB_ORDER == attrib_order
			);
		}
	
		if (parseFloat(changedFormulaAttribVal[0].ATTRIB_VALUE) !== Math.round(calculatedVal)) {
			changedFormulaAttribVal[0].ATTRIB_VALUE = Math.round(calculatedVal).toString();
		} else {
			changedFormulaAttribVal[0].ATTRIB_VALUE = Math.round(calculatedVal).toString();
		}
		}
	}

	reset(): void {
		this.formList = _.cloneDeep(this.originalData);
		this.outerList = _.cloneDeep(this.originalOutterData);

		this.originalTabsList.push(this.formList);
		this.originalTablsOutterList.push(this.outerList);
	}

	save(): void {
		this.isSaveClicked = true;

		const returnClobSettingsObj: any = {};
		const schdM2SaveDtls: any[] = [];
		this.scheduleM2SaveList = this.formList.filter((o: any) => o.ATTRIB_COL !== 'a');
		for (const key in this.scheduleM2SaveList) {
		if (Object.prototype.hasOwnProperty.call(this.scheduleM2SaveList, key)) {
			const item = this.scheduleM2SaveList[key];
			const returnObj: any = {};
			returnObj['object_id'] = this.data?.gridData?.rowData?.object_id;
			returnObj['combination_key'] = (item.ATTRIB_CLASS === 'DEF_ATTRIB') ? item.COMBINATION_KEY : item.PTR_COMBINATION_KEY;
			returnObj['ho_combination_key'] = item.COMBINATION_KEY;
			returnObj['form_key'] = item.FORM_KEY;
			returnObj['form_line_key'] = item.FORM_LINE_KEY;
			returnObj['line_attrib_key'] = item.LINE_ATTRIB_KEY;
			returnObj['trans_type_key'] = item.TRANS_TYPE_KEY;
			returnObj['attrib_type'] = item.ATTRIB_TYPE;
			returnObj['attrib_prop_key'] = item.ATTRIB_PROP_KEY;
			returnObj['acct_ref_key'] = item.ACCT_REF_KEY;
			returnObj['consol_group_key'] = item.CONSOL_GROUP_KEY;
			returnObj['attrib_value'] = item.ATTRIB_VALUE;
			schdM2SaveDtls.push(returnObj);
		}
		}

		returnClobSettingsObj['sso_id'] = this.logged_in_user;
		returnClobSettingsObj['screen_key'] = this.baseGlobalParams?.screen_key;
		returnClobSettingsObj['form_name'] = '1065';
		returnClobSettingsObj['schedule_name'] = 'M2K1';
		returnClobSettingsObj['combination_key'] = this.scheduleM2SaveList[0].COMBINATION_KEY;

		const message = 'Defaults has been successfully saved/updated';
		this.sendDetails(returnClobSettingsObj, schdM2SaveDtls, message);
	}

	private sendDetails(returnClobSettingsObj: any, schdM2SaveDtls: any[], message: string): void {
		this.f1065ScheduleM2ServiceFactory.saveSchdM2(this.baseURLs.api, returnClobSettingsObj, schdM2SaveDtls, this.globalService, this.rowData, this.filterParams).pipe(takeUntilDestroyed(this.destroyRef))
		.subscribe((result: any) => {
			// Check for error - handle both result.errorMessage and result.data.errorMessage formats
			const errorMessage = result.errorMessage || result.data?.errorMessage;
			if (errorMessage && errorMessage !== 'null') {
				this.isSaveClicked = false;
				this.gtwSnackbarService.openSnackBar(errorMessage, 'gtw-snackbar--red');
			} else {
				this.gtwSnackbarService.openSnackBar(message, 'gtw-snackbar--green');
			this.requestGridUpdate.emit('refresh');
			}
		});
	}

	private formatDate(date: any, format: string): string {
		return date ? new Date(date).toLocaleDateString() : '';
	}


	getMatchingFormItem(row: any, headerCol: any): any[] {
		return this.formList.filter(item => 
			item.FORM_LINE_KEY === row.FORM_LINE_KEY && 
			(item.ATTRIB_DESCRIPTION === headerCol.ATTRIB_DESCRIPTION || 
			 (headerCol.ATTRIB_DESCRIPTION === 'GTW Amount' && item.ATTRIB_DESCRIPTION === 'Per DCS Amount'))
		);
	}


	cancel() {
		this.requestGridUpdate.emit('cancel');
	}


	getColumnIndex(row1: any, row: any): number {
		return this.tableHeader.findIndex(header => {
			if (header.ATTRIB_DESCRIPTION === 'GTW Amount') {
				return row1.ATTRIB_DESCRIPTION === 'Per DCS Amount';
			}
			return header.ATTRIB_DESCRIPTION === row1.ATTRIB_DESCRIPTION;
		});
	}


}
